module.exports = __webpack_public_path__ + "img/coupon_get.2df42186.png";